import Immutable from 'immutable';

const viewSettingsMixin = {
  onSetViewSettingsToAppState({ catalogId, viewId, settings }) {
    // НОВАЯ СТРУКТУРА: viewSettings.catalogs[catalogId].views[viewId]
    const path = ['viewSettings', 'catalogs', String(catalogId), 'views', String(viewId)];

    this.setIn(path, Immutable.fromJS(settings));
    this.changed();
  },

  onMergeViewSettingsToAppState({ catalogId, viewId, settings }) {
    if (!settings) return; // Защита от undefined

    const path = ['viewSettings', 'catalogs', String(catalogId), 'views', String(viewId)];
    const existing = this.getIn(path) || Immutable.Map();

    const settingsImm = Immutable.fromJS(settings);
    let merged = existing;
    let hasChanges = false;

    // Для каждого ключа проверяем, содержит ли он массивы
    settingsImm.forEach((value, key) => {
      const existingValue = merged.get(key);

      if (Immutable.Map.isMap(value)) {
        // Проверяем, есть ли массивы внутри объекта
        const hasArrays = value.some((v) => Immutable.List.isList(v));

        if (hasArrays) {
          // Если есть массивы (pivot, etc), используем merge вместо mergeDeep
          // чтобы массивы заменялись полностью, а не мержились поэлементно
          const existingViewMode = merged.get(key) || Immutable.Map();
          const mergedViewMode = existingViewMode.merge(value);

          if (!existingViewMode.equals(mergedViewMode)) {
            merged = merged.set(key, mergedViewMode);
            hasChanges = true;
          }
        } else {
          // Если нет массивов (table, cards, etc), используем mergeDeep
          const newMerged = merged.mergeDeep(Immutable.Map({ [key]: value }));
          if (!merged.equals(newMerged)) {
            merged = newMerged;
            hasChanges = true;
          }
        }
      } else {
        // Для примитивов просто set
        if (existingValue !== value) {
          merged = merged.set(key, value);
          hasChanges = true;
        }
      }
    });

    // Триггерим changed только если что-то действительно изменилось
    if (hasChanges) {
      this.setIn(path, merged);
      this.changed();
    }
  },

  onSetViewSettingsClipboard({ catalogId, viewId, settings }) {
    this.setIn(
      ['viewSettingsClipboard'],
      Immutable.fromJS({
        catalogId: String(catalogId),
        viewId: String(viewId),
        settings,
      }),
    );
    this.changed();
  },

  onClearViewSettingsClipboard() {
    this.setIn(['viewSettingsClipboard'], null);
    this.changed();
  },
};

export default viewSettingsMixin;
